import BottomBar from "../components/map/BottomBar";
import { useNavigate } from "react-router-dom";
import { MdBackspace } from "react-icons/md";
import React, { useContext, useEffect } from "react";
import useIsLargeScreen from "../utils/useIsLargeScreen";
import SideBar from "../components/menu/SideBar";
import logoBari from "../assets/images/layout_set_logo.png";
import donaBari from "../assets/images/donalogo.jpg";
import logoVerner from "../assets/images/logoverner.jpg";
import BackBtn from "../components/menu/BackBtn";
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import logo from "../assets/images/ti pianto per amore-APP-verde.png";
import { VersionContext } from "../context/VersionContext";
import BackBtnLarge from "../components/menu/BackBtnLarge";

const ChiSiamo = () => {
  const { version } = useContext(VersionContext);
  useEffect(() => {
    version();
  }, []);
  const isLargeScreen = useIsLargeScreen();

  return (
    <div className=''>
      {isLargeScreen && <SideBar />}
      <div className='section-page section-full-page section-large page-large-container green-background min-100'>
        <BackBtn />
        {isLargeScreen && <BackBtnLarge />}
        <section className='chi-article blue-background menu-section-center pb-5'>
          <div className='section-center'>
            <h2 className='section-title pt-4'>Chi siamo</h2>
            <div className=''>
              <h4>Ti pianto per amore</h4>
            </div>
            <p>
              L'iniziativa{" "}
              <span className='cl-brown fw-bold'>"Ti pianto per amore"</span>{" "}
              voluta dall'Associazione culturale no-profit{" "}
              <span className='cl-brown fw-bold'>"Amici di Ernest Verner"</span>{" "}
              promuove l'adozione di alberi da parte di privati da piantare in
              punti della città di Bari privi di verde, in ottemperanza al
              Disciplinare tecnico (20/05/25) dell'iniziativa "Dona un albero
              alla tua città" del Comune di Bari.
            </p>
            <p className='pb-5 mb-0'>
              {" "}
              L'app permette di localizzare queste zone e prenotare l'acquisto
              di un albero con apposita targa da dedicare. La filosofia di
              questa iniziativa è prendersi cura del verde pubblico ed è per
              questo che coloro che acquistano gli alberi si impegnano a
              innaffiarli regolarmente, soprattutto d'estate, almeno nei primi
              due anni dalla piantumazione.
            </p>
            <div className='logo-chi-siamo d-flex justify-content-center pb-3 py-lg-5'>
              <img src={logo} alt='' srcset='' />
            </div>
          </div>
        </section>
        <section className='chi-logo-section py-5 pt-lg-5 white-background'>
          <div className='section-center'>
            <h4 className=''>Patrocini</h4>

            <div className='py-5 logo-container d-flex flex-column flex-lg-row justify-content-around w-100'>
              <div className='single-logo mb-5 mb-lg-0'>
                {" "}
                <a
                  href='https://www.ernestverner.it/'
                  className='logo-background logo-verner'
                ></a>
              </div>
              <div className='single-logo mb-5 mb-lg-0'>
                {" "}
                <a
                  href='https://www.comune.bari.it/'
                  className='logo-background logo-city'
                ></a>
              </div>
              <div className='single-logo'>
                {" "}
                <a
                  href='https://www.comune.bari.it/web/ambiente-verde-energia-e-impianti/dona-un-albero-alla-tua-citta'
                  className='logo-background logo-dona'
                ></a>
              </div>
            </div>
          </div>
        </section>
        <section className='py-5 yellow-background'>
          <div className='section-center'>
            <h4>Seguici sui nostri canali</h4>
            <div className='mt-5 d-flex flex-column  justify-content-around align-items-center w-100'>
              <article className='contacts-social-icon mb-4'>
                <a
                  target='_blank'
                  href='https://www.instagram.com/tipiantoperamore?igsh=MWY5cTFhZWJ2NXM2eQ=='
                >
                  {" "}
                  <FaInstagram />
                </a>
              </article>
              <article className='contacts-social-icon mb-4'>
                <a
                  target='_blank'
                  href='https://www.facebook.com/ti.pianto.per.amore/'
                >
                  {" "}
                  <FaFacebookF />
                </a>
              </article>
              <article className='contacts-social-icon mb-4'>
                <a target='_blank' href='  https://x.com/Amici_ErnestV'>
                  {" "}
                  <FaXTwitter />
                </a>
              </article>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ChiSiamo;
